import { APP_ROUTES } from '@/constants';
import NoAccessPage from '@/views/no-access-page.vue';

export const noAccessRoute = {
  path: APP_ROUTES.NO_ACCESS.PATH,
  name: APP_ROUTES.NO_ACCESS.NAME,
  component: NoAccessPage,
};
